module.exports = __webpack_public_path__ + "img/1.d58b845f.jpg";